<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
const hexToRgb = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  // eslint-disable-next-line no-param-reassign
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  /* eslint-disable indent */
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
  /* eslint-enable */
};

let xData = [
  "2025年3月",
  "2025年6月",
  "2025年7月",
  "2025年9月",
  "2025年11月",
  "2026年1月",
  "2026年3月",
];

const yData = [
  {
    name: "全国",
    data: [3.62, 2.84, 1.07, 1.58, 2.44, 2.74, 2.58],
  },
  {
    name: "上蔡",
    data: [3.33, 2.99, 1.22, 1.91, 2.51, 2.88, 2.71],
  },
];

const xAxisFn = (xData) => {
  return [
    {
      type: "category",
      boundaryGap: false,
      data: xData,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        //坐标轴刻度标签的相关设置
        textStyle: {
          color: "#FFFFFF",
          fontSize: 26,
          padding: [0, 0, 0, 0],
        },
        interval: 0,
        formatter: function (params) {
          var str = ""; // 最终拼接成的字符串
          var paramsLen = params.length; // 获取每项文字的个数
          var len = 5; // 每行能显示的字的个数（根据实际情况自己设置）
          var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
          if (paramsLen > len) {
            //大于设定的len就换行，不大于就不变化
            for (var i = 0; i < rowNumber; i++) {
              var temp = ""; // 表示每一次截取的字符串
              var start = i * len; // 开始截取的位置
              var end = start + len; // 结束截取的位置
              if (i == rowNumber - 1) {
                // 最后一次不换行
                temp = params.substring(start, paramsLen);
              } else {
                // 每一次拼接字符串并换行
                temp = params.substring(start, end) + "\n";
              }
              str += temp; // 最终拼成的字符串
            }
          } else {
            // 给新的字符串赋值
            str = params;
          }
          return str; //返回字符串
        },
      },
    },
  ];
};

const colorList = ["#107FFF", "#1AD4D5"];

const option = {
  series: yData.map((item, index) => {
    const rgb = hexToRgb(colorList[index]);
    const end = `rgba(${rgb.r},${rgb.g},${rgb.b},0)`;
    return {
      name: item.name,
      data: item.data,
      type: "line",
      smooth: true,
      showSymbol: false,
      // symbol: 'none',
      symbolSize: 26,
      emphasis: { focus: "series" },
      animationDuration: 2500,
      animationEasing: "cubicInOut",
      lineStyle: {
        width: 4,
      },
      areaStyle: {
        width: 4,
        opacity: 0.25,
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0.389, color: colorList[index] },
            { offset: 1, color: end },
          ],
          global: false,
        },
      },
    };
  }),
  tooltip: {
    trigger: "axis",
    show: false,
    axisPointer: {
      type: "line",
    },

    // formatter: '{a}: {c}',
    textStyle: {
      color: "#fafafa",
    },
    borderColor: "transparent",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    extraCssText: "backdrop-filter: blur(6px);",
  },
  grid: {
    top: "18%",
    left: "5%",
    right: "5%",
    bottom: "0%",
    containLabel: true,
  },
  legend: {
    show: true,
    right: "10%",
    top: "5%",

    icon: "roundRect",
    itemHeight: 25,
    itemWidth: 25,
    itemGap: 70,
    textStyle: {
      fontSize: 30,
      color: "#fafafa",
    },
    itemStyle: {
      borderColor: "transparent",
      borderWidth: 20,
    },
  },
  xAxis: xAxisFn(xData),
  yAxis: [
    {
      type: "value",
      name: "单位：元/斤",
      nameTextStyle: {
        color: "#fff",
        fontSize: 30,
        padding: [20, 0, 0, 100],
      },
      axisLabel: {
        //坐标轴刻度标签的相关设置
        textStyle: {
          color: "#FFFFFF",
          fontSize: 26,
        },
      },
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
